import {Box, Typography} from "@material-ui/core"
import React from "react"

const text = "Powered by Risk Mentor Digital Engines"
interface IFooterProps {
  logoUrl?: string
}
const Footer: React.FunctionComponent<IFooterProps> = ({logoUrl}) => {
  return (
    <Box
      color="white"
      bgcolor="primary.main"
      display="flex"
      position="absolute"
      bottom={0}
      justifyContent="flex-start"
      paddingY={1}
      width="inherit"
      alignItems="center"
      overflow="visible"
      maxHeight="40px"
    >
      <Box marginRight={5} />
      {logoUrl && (
        <Box component="span" alignSelf="flex-end">
          <img src={logoUrl} width="115%" alt="RiskMentor Logo" />
        </Box>
      )}
      <Box mr={2} />
      <Typography variant="subtitle1">{text}</Typography>
    </Box>
  )
}

export default Footer
